module.exports = __webpack_public_path__ + "img/logo.772a7901.svg";